/**
 * en-US
 * */

export default {
	nav: {
		home: "Home",
		tranning: "Tranning",
		competitions: "Competitions",
		discussion: "Discussion",
		datasets: "Data Sets",
		holdCompetition: "Hold Competition",
		information: "Information",
		message: "Message",
		login: "Login",
		register: "Register",
		mymainpage: "My Main Page",
		editsetting: "Edit Settings",
		signout: "Sign Out",
		work:'Working table',
	},
	home: {
        search: 'Search',
    }
};
